import { StockMasterType, StockMasterActionsList } from "../actions/stockMasterAction";
import { Action } from "../actions/types";

const initialValue: Array<StockMasterType> = []

export const stockMasterReducer = (state: StockMasterType[] = initialValue, action: Action) => {

    switch (action.type) { 
        case StockMasterActionsList.FETCH_STOCKMASTER:
            return action.data;
        case StockMasterActionsList.EDIT_STOCKMASTER: {
        
                    const updated = [...state].slice()
                    const index = updated.findIndex(u => {
                        return u.id === action.id
                    })
        
                    if (index > -1) {
                        updated[index] = {
                            ...updated[index],
                            ...action.data,
                            id: updated[index].id // Ensure 'id' is always present and of type number
                        }
                    }
        
                    return updated
                }
        default :
            return state
    }
}